import { api } from '../../../utils/api';

/**
 * 미리보기 HTML을 Bearer 인증으로 가져옵니다.
 * iframe src 직접 로드 시 Authorization 이 없어 로그인 페이지로 리다이렉트되고
 * X-Frame-Options: deny 로 차단되는 문제를 피합니다.
 */
export async function fetchReportPreviewHtml(reportRequestSysId) {
  if (reportRequestSysId == null || String(reportRequestSysId).trim() === '') {
    throw new Error('reportRequestSysId가 없습니다.');
  }
  const html = await api.get(
    `/doc-management/api/output/view?reportRequestId=${encodeURIComponent(reportRequestSysId)}`,
    { responseType: 'text' }
  );
  const raw = typeof html === 'string' ? html : String(html ?? '');
  return injectPreviewBaseHref(raw);
}

/** srcDoc 문서에서 루트 상대 경로(/doc-management/...)가 앱 오리진을 기준으로 동작하도록 */
export function injectPreviewBaseHref(html) {
  const base = `${typeof window !== 'undefined' ? window.location.origin : ''}/`;
  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head([^>]*)>/i, `<head$1><base href="${base}">`);
  }
  if (/<html[^>]*>/i.test(html)) {
    return html.replace(/<html([^>]*)>/i, `<html$1><head><base href="${base}"></head>`);
  }
  return `<!DOCTYPE html><html><head><base href="${base}"></head><body>${html}</body></html>`;
}
